import ErrorBoundary from '@/components/ErrorBoundary';
import { DefaultComponent } from '@/types/component';
import { withDebugMetadata } from 'lib/utils';
import component from 'modules/dynamic-components';

const ArticleVideo = component('ContentJwVideoArticle');
const VideoTeaser = component('ContentJwVideoTeaser');

const DefaultJwVideo: DefaultComponent= ({ data, type, meta, descendants }) => {
  const { enableShop, enableTeaser } = data;
  if (enableShop) return null;
  if (enableTeaser)
    return (
      <ErrorBoundary>
        <VideoTeaser
          data={data}
          type={type}
          meta={meta}
          descendants={descendants}
          {...withDebugMetadata({ type, meta })}
        />
      </ErrorBoundary>
    );

  return (
    <ErrorBoundary>
      <ArticleVideo
        data={data}
        type={type}
        meta={meta}
        descendants={descendants}
        {...withDebugMetadata({ type, meta })}
      />
    </ErrorBoundary>
  );
};
export default DefaultJwVideo;
